<small class="debug">{{ me }}</small>
<div appPreventPullToRefresh class="mobile-container">
    @switch (viewMode) {
        <!-- ==================== LOGIN VIEW ==================== -->
        @case (EnumViewMode.NOT_LOGGED_IN) {
            <!-- Theme Selector -->
            <div class="theme-selector-wrapper" style="position: absolute; top: 10px; right: 10px; z-index: 1000;">
                <app-theme-selector></app-theme-selector>
            </div>

            <div translate="no" fxLayout="column" fxLayoutAlign="center center" style="padding-top: 50px"
                 fxLayoutGap="0px">
                <img style="width: 180px; padding-bottom: 30px" src="./assets/police_israel_logo.png" />
                <div fxLayout="row" fxLayoutGap="1px" fxLayoutAlign="center center">
                    <mat-label style="font-size: 2em">קוד כניסה</mat-label>
                </div>
                <br />
                <div fxLayout="row" fxLayoutGap="1px" fxLayoutAlign="center center">
                    <mat-form-field
                        appearance="outline"
                        color="warn"
                        *ngFor="let control of inputControls; let i = index"
                        class="otp-form-field"
                    >
                        <input
                            style="font-size: 2em"
                            class="otp-input shake-input"
                            matInput
                            [disabled]="isDisabledLogin"
                            maxlength="1"
                            type="text"
                            (input)="onInput($event, i)"
                            (keyup)="onLoginCheck()"
                            (keydown.backspace)="onBackspace($event, i)"
                            [(ngModel)]="inputValues[i]"
                            #inputBox
                        />
                    </mat-form-field>
                </div>
                <div style="text-align: center">
                    <div mat-dialog-actions style="justify-content: center">
                        <button mat-icon-button (click)="clearInputs()">
                            <mat-icon class="mat-icon-large">highlight_off</mat-icon>
                        </button>
                    </div>
                    <br />
                </div>
                <br />
                <br />
                <div fxLayout="column" fxLayoutAlign="center center" style="opacity: 0.5">
                    <mat-label style="padding-top: 5px">
                        נגזרת על פי נוהל מספר 02.220.202
                    </mat-label>
                </div>
                <br />
                <br />
                <mat-label style="padding-top: 5px">
                    version {{ version }}
                </mat-label>
                <br />
                <button mat-button style="opacity: 0.1" (click)="clearPwa()">
                    clear settings
                </button>
                <br />
            </div>
        }

        <!-- ==================== INITIAL INFO FORM VIEW ==================== -->
        @case (EnumViewMode.CHECKING_1) {
            <!-- Theme Selector -->
            <div class="theme-selector-wrapper" style="position: absolute; top: 10px; right: 10px; z-index: 1000;">
                <app-theme-selector></app-theme-selector>
            </div>

            <div translate="no" class="info-form-view">
                <div class="logo-container">
                    <img style="width: 180px; padding-bottom: 30px" src="./assets/police_israel_logo.png" />
                </div>

                <mat-card class="info-card">
                    <mat-card-header>
                        <mat-card-title class="card-title">פרטי שוטר ורכב</mat-card-title>
                    </mat-card-header>

                    <mat-card-content class="form-content">
                        <!-- קוד קריאה -->
                        <mat-form-field appearance="fill" class="form-field">
                            <mat-label>קוד קריאה</mat-label>
                            <span matPrefix class="equipment-emoji" aria-label="call code" role="img">📟</span>
                            <mat-select (selectionChange)="checkStartCheckReady();isDebugModeCodeCall()" [(ngModel)]="selectedCodeCall">
                                <mat-option *ngFor="let lev of callIds" [value]="lev">
                                    <mat-label>{{ lev }}</mat-label>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- שם פרטי -->
                        <mat-form-field appearance="fill" class="form-field">
                            <mat-label>שם פרטי</mat-label>
                            <span matPrefix class="equipment-emoji" aria-label="user name" role="img">👤</span>
                            <input
                                (keyup)="checkStartCheckReady()"
                                [(ngModel)]="userName"
                                matInput
                                type="text"
                                name="SearchDualList"
                                autocomplete="off"
                            />
                            <button mat-icon-button matSuffix (click)="userName = ''; checkStartCheckReady()" aria-label="Clear">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>

                        <!-- מספר ניידת -->
                        <mat-form-field appearance="fill" class="form-field">
                            <mat-label>מספר ניידת</mat-label>
                            <span matPrefix class="equipment-emoji" aria-label="police car" role="img">🚓</span>
                            <mat-select (selectionChange)="onSelectedVehicle(); checkStartCheckReady()" [(ngModel)]="selectedVehicle">
                                <mat-option *ngFor="let vehicle of vehicles" [value]="vehicle">
                                    <mat-label>{{ vehicle.id }}</mat-label>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- ראש משמרת -->
                        <mat-form-field appearance="fill" class="form-field">
                            <mat-label>ראש משמרת</mat-label>
                            <span matPrefix class="equipment-emoji" aria-label="shift commander" role="img">👮‍♂️</span>
                            <mat-select (selectionChange)="onSelectedCaptain(); checkStartCheckReady()" [(ngModel)]="selectedCaptain">
                                <mat-option *ngFor="let item of emailSendTo" [value]="item">
                                    <mat-label>{{ item.name }}</mat-label>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <!-- מספר אישי -->
                        <mat-form-field appearance="fill" class="form-field">
                            <mat-label>מספר אישי</mat-label>
                            <span matPrefix class="equipment-emoji" aria-label="badge number" role="img">🆔</span>
                            <input
                                (keyup)="checkStartCheckReady()"
                                [(ngModel)]="officerId"
                                inputrestriction="numbers"
                                matInput
                                type="number"
                                name="SearchDualList"
                                autocomplete="off"
                            />
                            <button mat-icon-button matSuffix (click)="officerId = ''; checkStartCheckReady()" aria-label="Clear">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </mat-card-content>

                    <mat-card-actions class="card-actions">
                        <button
                            class="primary-action-button"
                            [disabled]="startCheckDisabled"
                            mat-raised-button
                            color="warn"
                            (click)="start()"
                        >
                            המשך
                        </button>

                        <div class="checkbox-container">
                            <mat-checkbox [(ngModel)]="kitatKonenut" (change)="setKitatKonenoot($event)">
                                <mat-label class="checkbox-label">כיתת כוננות</mat-label>
                            </mat-checkbox>
                        </div>

                        <button mat-stroked-button class="secondary-button" (click)="installPwa()">
                            הורדת האפליקציה
                            <mat-icon>get_app</mat-icon>
                        </button>
                    </mat-card-actions>
                </mat-card>

                <div class="footer-info">
                    <mat-label class="version-label">version {{ version }}</mat-label>
                    <button mat-button class="clear-settings-button" (click)="clearPwa()">
                        clear settings
                    </button>
                </div>
            </div>
        }

        <!-- ==================== EQUIPMENT WIZARD VIEW ==================== -->
        @case (EnumViewMode.CHECKING_2) {
            <form [formGroup]="form" (focusout)="allControlsAllWizardsCheck()" class="wizard-form">
                <mat-horizontal-stepper linear #stepper (animationDone)="createReport()" class="mobile-stepper">

                    <!-- ==================== STEP 1: PERSONAL EQUIPMENT ==================== -->
                    <mat-step [completed]="!wizardDisabled1" [editable]="true">
                        <ng-template matStepLabel>ציוד אישי</ng-template>

                        <div class="step-content">
                            <mat-card class="equipment-section-card">
                                <mat-card-header>
                                    <mat-card-subtitle>תיקים וציוד מיוחד</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <!-- תיקיות Checkbox -->
                                    <div class="checkbox-field">
                                        <mat-checkbox
                                            formControlName="תיקיות"
                                            (change)="onTikiyotChange($event); allControlsTouchedPage1('תיקיות')"
                                            [ngClass]="{'error-border-wrapper': !form.controls['תיקיות'].touched}"
                                        >
                                            <span class="equipment-emoji" aria-label="bags kit" role="img">📁</span>
                                            <mat-label class="checkbox-label">תיקיות</mat-label>
                                        </mat-checkbox>
                                    </div>

                                    <!-- Conditional Bag Fields -->
                                    <div class="conditional-fields" *ngIf="tikiyotSelected">
                                        <!-- תיק מחסומים -->
                                        <mat-form-field appearance="fill" class="form-field"
                                            [ngClass]="{'error-border': !form.controls['תיק_מחסומים'].touched}">
                                            <mat-label>תיק מחסומים</mat-label>
                                            <span matPrefix class="equipment-emoji" aria-label="barrier kit" role="img">🚧</span>
                                            <mat-select
                                                formControlName="תיק_מחסומים"
                                                (selectionChange)="allControlsTouchedPage1('תיק_מחסומים'); checkStartCheckReady()"
                                                [ngClass]="{'error-border': form.controls['תיק_מחסומים'].invalid && form.controls['תיק_מחסומים'].touched}"
                                            >
                                                <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                    <mat-label>{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- תיק סיור -->
                                        <mat-form-field appearance="fill" class="form-field"
                                            [ngClass]="{'error-border': !form.controls['תיק_סיור'].touched}">
                                            <mat-label>תיק סיור</mat-label>
                                            <span matPrefix class="equipment-emoji" aria-label="patrol kit" role="img">🧳</span>
                                            <mat-select
                                                formControlName="תיק_סיור"
                                                (selectionChange)="allControlsTouchedPage1('תיק_סיור'); checkStartCheckReady()"
                                                [ngClass]="{'error-border': form.controls['תיק_סיור'].invalid && form.controls['תיק_סיור'].touched}"
                                            >
                                                <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                    <mat-label>{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- תיק שטח -->
                                        <mat-form-field appearance="fill" class="form-field"
                                            [ngClass]="{'error-border': !form.controls['תיק_שטח'].touched}">
                                            <mat-label>תיק שטח</mat-label>
                                            <span matPrefix class="equipment-emoji" aria-label="field kit" role="img">📂</span>
                                            <mat-select
                                                formControlName="תיק_שטח"
                                                (selectionChange)="allControlsTouchedPage1('תיק_שטח'); checkStartCheckReady()"
                                                [ngClass]="{'error-border': form.controls['תיק_שטח'].invalid && form.controls['תיק_שטח'].touched}"
                                            >
                                                <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                    <mat-label>{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- תיק פיזור Checkbox -->
                                    <div class="checkbox-field">
                                        <mat-checkbox
                                            formControlName="תיק_פיזור"
                                            (change)="onTikPizorChange($event); allControlsTouchedPage1('תיק_פיזור')"
                                            [ngClass]="{'error-border-wrapper': !form.controls['תיק_פיזור'].touched}"
                                        >
                                            <span class="equipment-emoji" aria-label="dispersion kit" role="img">🎒</span>
                                            <mat-label class="checkbox-label">תיק פיזור</mat-label>
                                        </mat-checkbox>
                                    </div>

                                    <!-- Conditional Dispersion Equipment -->
                                    <div class="conditional-fields" *ngIf="tikPizorSelected">
                                        <!-- אפוד קרמי -->
                                        <mat-form-field appearance="fill" class="form-field"
                                            [ngClass]="{'error-border': !form.controls['אפוד_קרמי'].touched}">
                                            <mat-label>אפוד קרמי</mat-label>
                                            <span matPrefix class="equipment-emoji" aria-label="ballistic vest" role="img">🎽</span>
                                            <mat-select
                                                formControlName="אפוד_קרמי"
                                                (selectionChange)="allControlsTouchedPage1('אפוד_קרמי'); checkStartCheckReady()"
                                            >
                                                <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                    <mat-label>{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- אפוד מגן -->
                                        <mat-form-field appearance="fill" class="form-field"
                                            [ngClass]="{'error-border': !form.controls['אפוד_מגן'].touched}">
                                            <mat-label>אפוד מגן</mat-label>
                                            <span matPrefix class="equipment-emoji" aria-label="protective vest" role="img">🛡️</span>
                                            <mat-select
                                                formControlName="אפוד_מגן"
                                                (selectionChange)="allControlsTouchedPage1('אפוד_מגן'); checkStartCheckReady()"
                                                [ngClass]="{'error-border': form.controls['אפוד_מגן'].invalid && form.controls['אפוד_מגן'].touched}"
                                            >
                                                <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                    <mat-label>{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- קסדה -->
                                        <mat-form-field appearance="fill" class="form-field"
                                            [ngClass]="{'error-border': !form.controls['קסדה'].touched}">
                                            <mat-label>קסדה</mat-label>
                                            <span matPrefix class="equipment-emoji" aria-label="helmet" role="img">🪖</span>
                                            <mat-select
                                                formControlName="קסדה"
                                                (selectionChange)="allControlsTouchedPage1('קסדה'); checkStartCheckReady()"
                                                [ngClass]="{'error-border': form.controls['קסדה'].invalid && form.controls['קסדה'].touched}"
                                            >
                                                <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                    <mat-label>{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- אלה -->
                                        <mat-form-field appearance="fill" class="form-field"
                                            [ngClass]="{'error-border': !form.controls['אלה'].touched}">
                                            <mat-label>אלה</mat-label>
                                            <span matPrefix class="equipment-emoji" aria-label="baton" role="img">🦯</span>
                                            <mat-select
                                                formControlName="אלה"
                                                (selectionChange)="allControlsTouchedPage1('אלה'); checkStartCheckReady()"
                                                [ngClass]="{'error-border': form.controls['אלה'].invalid && form.controls['אלה'].touched}"
                                            >
                                                <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                    <mat-label>{{ item }}</mat-label>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <mat-card class="equipment-section-card">
                                <mat-card-header>
                                    <mat-card-subtitle>ציוד חובה</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <!-- מספר קשר (א) -->
                                    <mat-form-field appearance="fill" class="form-field">
                                        <mat-label>*קשר (א)</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="radio number" role="img">
                                            <fa-icon size="2x" class="fa-lg-icon" [icon]="faWalkieTalkie"></fa-icon>
                                        </span>
                                        <input
                                            (focusout)="form.controls['מספר_קשר1'].markAsTouched(); allControlsTouchedPage1('מספר_קשר1')"
                                            formControlName="מספר_קשר1"
                                            inputrestriction="basic1"
                                            matInput
                                            type="string"
                                            autocomplete="off"
                                        />
                                    </mat-form-field>

                                    <!-- מספר נשק (א) -->
                                    <mat-form-field appearance="fill" class="form-field">
                                        <mat-label>*נשק (א)</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="weapon number" role="img">
                                            <fa-icon size="2x" class="fa-lg-icon weapon-icon" [icon]="faPersonRifle"></fa-icon>
                                        </span>
                                        <input
                                            (focusout)="form.controls['מספר_נשק'].markAsTouched(); allControlsTouchedPage1('מספר_נשק')"
                                            formControlName="מספר_נשק"
                                            inputrestriction="basic1"
                                            matInput
                                            type="number"
                                            autocomplete="off"
                                        />
                                    </mat-form-field>

                                    <!-- מספר טאבלט -->
                                    <mat-form-field appearance="fill" class="form-field">
                                        <mat-label>*טאבלט</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="tablet number" role="img">📱</span>
                                        <input
                                            (focusout)="form.controls['מספר_טאבלט'].markAsTouched(); allControlsTouchedPage1('מספר_טאבלט')"
                                            formControlName="מספר_טאבלט"
                                            inputrestriction="alphanums"
                                            matInput
                                            type="text"
                                            autocomplete="off"
                                        />
                                    </mat-form-field>
                                </mat-card-content>
                            </mat-card>

                            <mat-card class="equipment-section-card">
                                <mat-card-header>
                                    <mat-card-subtitle>ציוד נוסף (אופציונלי)</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <!-- מספר קשר (ב) -->
                                    <mat-form-field appearance="fill" class="form-field">
                                        <mat-label>קשר (ב)</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="radio number" role="img">
                                            <fa-icon size="2x" class="fa-lg-icon" [icon]="faWalkieTalkie"></fa-icon>
                                        </span>
                                        <input
                                            (focusout)="form.controls['מספר_קשר2'].markAsTouched(); allControlsTouchedPage1('מספר_קשר2')"
                                            formControlName="מספר_קשר2"
                                            inputrestriction="basic1"
                                            matInput
                                            type="string"
                                            autocomplete="off"
                                        />
                                    </mat-form-field>

                                    <!-- מספר נשק (ב) -->
                                    <mat-form-field appearance="fill" class="form-field">
                                        <mat-label>נשק (ב)</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="weapon number" role="img">
                                            <fa-icon size="2x" class="fa-lg-icon weapon-icon" [icon]="faPersonRifle"></fa-icon>
                                        </span>
                                        <input
                                            (focusout)="form.controls['מספר_נשק2'].markAsTouched(); allControlsTouchedPage1('מספר_נשק2')"
                                            formControlName="מספר_נשק2"
                                            inputrestriction="basic1"
                                            matInput
                                            type="number"
                                            autocomplete="off"
                                        />
                                    </mat-form-field>

                                    <!-- מספר טייזר -->
                                    <mat-form-field appearance="fill" class="form-field">
                                        <mat-label>טייזר</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="taser number" role="img">
                                            <fa-icon size="2x" class="fa-lg-icon taser-icon" [icon]="faGun"></fa-icon>
                                        </span>
                                        <input
                                            (focusout)="form.controls['מספר_טייזר'].markAsTouched(); allControlsTouchedPage1('מספר_טייזר')"
                                            formControlName="מספר_טייזר"
                                            inputrestriction="alphanums"
                                            matInput
                                            type="text"
                                            autocomplete="off"
                                        />
                                    </mat-form-field>

                                    <!-- אזיק רגליים -->
                                    <mat-form-field appearance="fill" class="form-field">
                                        <mat-label>אזיק רגליים</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="leg cuffs" role="img">
                                            <fa-icon size="2x" class="fa-lg-icon handcuffs-icon" [icon]="faHandcuffs"></fa-icon>
                                        </span>
                                        <input
                                            (focusout)="form.controls['אזיק_רגליים'].markAsTouched(); allControlsTouchedPage1('אזיק_רגליים')"
                                            formControlName="אזיק_רגליים"
                                            inputrestriction="alphanums"
                                            matInput
                                            type="text"
                                            autocomplete="off"
                                        />
                                    </mat-form-field>
                                </mat-card-content>
                            </mat-card>

                            <div class="step-actions">
                                <button
                                    [disabled]="wizardDisabled1"
                                    mat-raised-button
                                    color="warn"
                                    class="next-button"
                                    (click)="stepper.next(); resetFormControlsPage2()"
                                >
                                    המשך
                                    <mat-icon>arrow_back</mat-icon>
                                </button>

                                <mat-label *ngIf="lastZivud" class="last-zivud-label">
                                    זיווד אחרון ע"י {{ lastZivud.userName }} ב: {{ lastZivud.dateTime }}
                                </mat-label>
                            </div>
                        </div>
                    </mat-step>

                    <!-- ==================== STEP 2: VEHICLE EQUIPMENT ==================== -->
                    <mat-step [completed]="!wizardDisabled2">
                        <ng-template matStepLabel>נידת</ng-template>

                        <div class="step-content">
                            <mat-card class="equipment-section-card">
                                <mat-card-header>
                                    <mat-card-subtitle>ציוד רכב - חלק א'</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <!-- גשר תאורה מהבהב -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['גשר_תאורה_מהבהב'].touched}">
                                        <mat-label>גשר אור מהבהב</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="police light" role="img">🚨</span>
                                        <mat-select
                                            formControlName="גשר_תאורה_מהבהב"
                                            (selectionChange)="allControlsTouchedPage2('גשר_תאורה_מהבהב'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['גשר_תאורה_מהבהב'].invalid && form.controls['גשר_תאורה_מהבהב'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- מחסום סטינגר דוקרנים -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['מחסום_סטינגר_דוקרנים'].touched}">
                                        <mat-label>סטינגר דוקרנים</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="road spikes" role="img">🪝</span>
                                        <mat-select
                                            formControlName="מחסום_סטינגר_דוקרנים"
                                            (selectionChange)="allControlsTouchedPage2('מחסום_סטינגר_דוקרנים'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['מחסום_סטינגר_דוקרנים'].invalid && form.controls['מחסום_סטינגר_דוקרנים'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- אוהל מחסום -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['אוהל_מחסום'].touched}">
                                        <mat-label>אוהל מחסום</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="checkpoint tent" role="img">⛺</span>
                                        <mat-select
                                            formControlName="אוהל_מחסום"
                                            (selectionChange)="allControlsTouchedPage2('אוהל_מחסום'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['אוהל_מחסום'].invalid && form.controls['אוהל_מחסום'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- בדיקת אומים -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['בדיקת_אומים'].touched}">
                                        <mat-label>בדיקת אומים</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="nuts check" role="img">⚙️</span>
                                        <mat-select
                                            formControlName="בדיקת_אומים"
                                            (selectionChange)="allControlsTouchedPage2('בדיקת_אומים'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['בדיקת_אומים'].invalid && form.controls['בדיקת_אומים'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- מגפון -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['מגפון'].touched}">
                                        <mat-label>מגפון</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="megaphone" role="img">📢</span>
                                        <mat-select
                                            formControlName="מגפון"
                                            (selectionChange)="allControlsTouchedPage2('מגפון'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['מגפון'].invalid && form.controls['מגפון'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- מתודלקת -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['מתודלקת'].touched}">
                                        <mat-label>מתודלקת</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="fuel gauge" role="img">⛽</span>
                                        <mat-select
                                            formControlName="מתודלקת"
                                            (selectionChange)="allControlsTouchedPage2('מתודלקת'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['מתודלקת'].invalid && form.controls['מתודלקת'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0%','10%','20%','30%','40%','50%','60%','70%','80%','90%','100%']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card-content>
                            </mat-card>

                            <mat-card class="equipment-section-card">
                                <mat-card-header>
                                    <mat-card-subtitle>ציוד רכב - חלק ב'</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <!-- חומ"ס -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['חומס'].touched}">
                                        <mat-label>חומ"ס</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="hazardous material" role="img">☣️</span>
                                        <mat-select
                                            formControlName="חומס"
                                            (selectionChange)="allControlsTouchedPage2('חומס'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['חומס'].invalid && form.controls['חומס'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- נצנצים טעונים -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['נצנצים_טעונים'].touched}">
                                        <mat-label>נצנץ טעון</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="charged strobe" role="img">🔋</span>
                                        <mat-select
                                            formControlName="נצנצים_טעונים"
                                            (selectionChange)="allControlsTouchedPage2('נצנצים_טעונים'); checkStartCheckReady(); createReport()"
                                            [ngClass]="{'error-border': form.controls['נצנצים_טעונים'].invalid && form.controls['נצנצים_טעונים'].touched}"
                                        >
                                            <mat-option *ngFor="let item of maxNaznaz" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- סס"ל -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['ססל'].touched}">
                                        <mat-label>סס"ל</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="pepper spray or similar" role="img">📏</span>
                                        <mat-select
                                            formControlName="ססל"
                                            (selectionChange)="allControlsTouchedPage2('ססל'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['ססל'].invalid && form.controls['ססל'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1','2','3','4','5']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- יריעה לגופה -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['יריעה_לגופה'].touched}">
                                        <mat-label>יריעה לגופה</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="body sheet" role="img">💀</span>
                                        <mat-select
                                            formControlName="יריעה_לגופה"
                                            (selectionChange)="allControlsTouchedPage2('יריעה_לגופה'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['יריעה_לגופה'].invalid && form.controls['יריעה_לגופה'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- סדר -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['סדר'].touched}">
                                        <mat-label>סדר</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="storm gear" role="img">🧹</span>
                                        <mat-select
                                            formControlName="סדר"
                                            (selectionChange)="allControlsTouchedPage2('סדר'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['סדר'].invalid && form.controls['סדר'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['נקיה','מלוכלכת','?']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- חליפת סערה -->
                                    <mat-form-field appearance="fill" class="form-field"
                                        [ngClass]="{'error-border': !form.controls['חליפת_סערה'].touched}">
                                        <mat-label>חליפת סערה</mat-label>
                                        <span matPrefix class="equipment-emoji" aria-label="storm gear" role="img">🧥</span>
                                        <mat-select
                                            formControlName="חליפת_סערה"
                                            (selectionChange)="allControlsTouchedPage2('חליפת_סערה'); checkStartCheckReady()"
                                            [ngClass]="{'error-border': form.controls['חליפת_סערה'].invalid && form.controls['חליפת_סערה'].touched}"
                                        >
                                            <mat-option *ngFor="let item of ['0','1','2']" [value]="item">
                                                <mat-label>{{ item }}</mat-label>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </mat-card-content>
                            </mat-card>

                            <mat-card class="equipment-section-card">
                                <mat-card-header>
                                    <mat-card-subtitle>בדיקות רכב</mat-card-subtitle>
                                </mat-card-header>
                                <mat-card-content>
                                    <div class="checkbox-groups">
                                        <!-- LEFT GROUP -->
                                        <div class="checkbox-group">
                                            <mat-checkbox
                                                class="master-checkbox"
                                                [checked]="isGroupAllChecked('left')"
                                                [indeterminate]="isGroupIndeterminate('left')"
                                                (change)="masterToggleGroup('left', $event.checked)"
                                            >
                                                <strong>סמון הכל</strong>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('ערכת_עזרה_ראשונה')"
                                                formControlName="ערכת_עזרה_ראשונה"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['ערכת_עזרה_ראשונה'].touched}">
                                                    ערכת עזרה ראשונה
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('מטף_כיבוי_לרכב')"
                                                formControlName="מטף_כיבוי_לרכב"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['מטף_כיבוי_לרכב'].touched}">
                                                    מטף כיבוי לרכב
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('מערכת_קשר')"
                                                formControlName="מערכת_קשר"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['מערכת_קשר'].touched}">
                                                    מערכת קשר תקינה
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('מערכת_כריזה')"
                                                formControlName="מערכת_כריזה"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['מערכת_כריזה'].touched}">
                                                    מערכת כריזה תקינה
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('מגבה_לרכב_ידית_מפתח')"
                                                formControlName="מגבה_לרכב_ידית_מפתח"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['מגבה_לרכב_ידית_מפתח'].touched}">
                                                    מגבה ידית מפתח
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('גלגל_ספייר')"
                                                formControlName="גלגל_ספייר"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['גלגל_ספייר'].touched}">
                                                    גלגל ספייר
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('אפודה_זוהרת')"
                                                formControlName="אפודה_זוהרת"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['אפודה_זוהרת'].touched}">
                                                    אפודה זוהרת
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('משולש_אזהרה')"
                                                formControlName="משולש_אזהרה"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['משולש_אזהרה'].touched}">
                                                    משולש אזהרה
                                                </mat-label>
                                            </mat-checkbox>
                                        </div>

                                        <!-- RIGHT GROUP -->
                                        <div class="checkbox-group">
                                            <mat-checkbox
                                                class="master-checkbox"
                                                [checked]="isGroupAllChecked('right')"
                                                [indeterminate]="isGroupIndeterminate('right')"
                                                (change)="masterToggleGroup('right', $event.checked)"
                                            >
                                                <strong>סמון הכל</strong>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('עמדת_עריסה')"
                                                formControlName="עמדת_עריסה"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['עמדת_עריסה'].touched}">
                                                    עמדת עריסה
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('מכשיר_נייד_מיקרופון')"
                                                formControlName="מכשיר_נייד_מיקרופון"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['מכשיר_נייד_מיקרופון'].touched}">
                                                    מכשיר נייד,מיקרופון
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('מצלמת_רוורס')"
                                                formControlName="מצלמת_רוורס"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['מצלמת_רוורס'].touched}">
                                                    מצלמת רוורס
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('מדפסת_נייר')"
                                                formControlName="מדפסת_נייר"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['מדפסת_נייר'].touched}">
                                                    מדפסת נייר
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('מגבר_צופר_רמקול_מיקרופון')"
                                                formControlName="מגבר_צופר_רמקול_מיקרופון"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['מגבר_צופר_רמקול_מיקרופון'].touched}">
                                                    צופר,רמקול,מיקרופון
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('נורת_בדוק_מנוע')"
                                                formControlName="נורת_בדוק_מנוע"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['נורת_בדוק_מנוע'].touched}">
                                                    נורת מנוע תקינה
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('נורת_בדוק_מצבר')"
                                                formControlName="נורת_בדוק_מצבר"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['נורת_בדוק_מצבר'].touched}">
                                                    נורת מצבר תקינה
                                                </mat-label>
                                            </mat-checkbox>

                                            <mat-checkbox
                                                (change)="allControlsTouchedPage2('adblue')"
                                                formControlName="adblue"
                                                class="checkbox-item"
                                            >
                                                <mat-label [ngClass]="{'error-border-wrapper': !form.controls['adblue'].touched}">
                                                    AdBlue נורת סולר
                                                </mat-label>
                                            </mat-checkbox>
                                        </div>
                                    </div>

                                    <!-- Odometer and Cell Cleaning -->
                                    <div class="additional-fields">
                                        <mat-form-field appearance="fill" class="odometer-field">
                                            <mat-label>קריאת ספידומטר</mat-label>
                                            <input
                                                matInput
                                                type="number"
                                                formControlName="קילומטראז"
                                                inputrestriction="numbers"
                                                (focusout)="form.controls['קילומטראז'].markAsTouched(); allControlsTouchedPage2('קילומטראז')"
                                                (keyup)="allControlsTouchedPage2('קילומטראז')"
                                                autocomplete="off"
                                                placeholder="קילומטראז"
                                            />
                                        </mat-form-field>

                                        <div class="cell-cleaning-container">
                                            <span class="status-icon">
                                                {{ form.get('טיהור_תא_עצורים')?.value ? '✅' : '⚠️' }}
                                            </span>
                                            <mat-checkbox
                                                formControlName="טיהור_תא_עצורים"
                                                [ngClass]="{'error-border-wrapper': !form.controls['טיהור_תא_עצורים'].touched}"
                                                (change)="allControlsTouchedPage2('טיהור_תא_עצורים')"
                                            >
                                                טיהור תא עצורים [ נבדק ]
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <div class="step-actions">
                                <button
                                    [disabled]="wizardDisabled2"
                                    mat-raised-button
                                    color="warn"
                                    class="next-button"
                                    (click)="createReport();stepper.next()"
                                >
                                    <mat-icon>arrow_back</mat-icon>
                                    המשך
                                </button>

                                <mat-label *ngIf="lastZivud" class="last-zivud-label">
                                    זיווד אחרון ע"י {{ lastZivud.userName }} ב:
                                    <span>{{ lastZivud.dateTime }}</span>
                                </mat-label>
                            </div>
                        </div>
                    </mat-step>

                    <!-- ==================== STEP 3: EQUIPMENT PHOTOS ==================== -->
                    <mat-step [completed]="!step1PhotosDisabled">
                        <ng-template matStepLabel>ציוד</ng-template>

                        <div class="step-content">
                            <mat-card class="photo-instructions-card">
                                <mat-card-header>
                                    <mat-card-title>אנא צלם תמונה עדכנית:</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <img src="./assets/images/police_equipment.png" class="reference-image" alt="Police Equipment" />
                                    <mat-list class="checklist">
                                        <mat-list-item>
                                            <mat-icon matListIcon>check_circle</mat-icon>
                                            <span class="item-text">2 אפודות קרמיות</span>
                                        </mat-list-item>
                                        <mat-list-item>
                                            <mat-icon matListIcon>check_circle</mat-icon>
                                            <span class="item-text">8 טרפזים</span>
                                        </mat-list-item>
                                        <mat-list-item>
                                            <mat-icon matListIcon>check_circle</mat-icon>
                                            <span class="item-text">6 נצנצים</span>
                                        </mat-list-item>
                                    </mat-list>
                                </mat-card-content>
                            </mat-card>

                            <!-- Serial Number Verifications -->
                            <div class="serial-verification-section">
                                @if (inSerialDev) {
                                    <!-- Vest 1 -->
                                    <div class="serial-card" [class.valid]="serialValid1 === true" [class.invalid]="serialValid1 === false">
                                        <mat-icon *ngIf="serialValid1 === true" class="validation-icon success-icon">check_circle</mat-icon>
                                        <mat-icon *ngIf="serialValid1 === false" class="validation-icon error-icon">cancel</mat-icon>

                                        <img src="./assets/images/police_vest.png" class="serial-image" alt="Police Vest" />

                                        <div class="serial-content">
                                            <mat-label class="serial-title">אפוד קרמי #1</mat-label>

                                            <div class="serial-inputs">
                                                <mat-form-field *ngFor="let control of inputControls1; let i = index" class="serial-input-field" appearance="fill">
                                                    <input
                                                        matInput
                                                        maxlength="1"
                                                        type="text"
                                                        inputrestriction="numbers"
                                                        pattern="[0-9]*"
                                                        (input)="onInput($event, i, 1)"
                                                        (keydown.backspace)="onBackspace($event, i, 1)"
                                                        #inputBox1
                                                        [(ngModel)]="inputValues1[i]"
                                                        [ngModelOptions]="{standalone: true}"
                                                    />
                                                </mat-form-field>
                                                <button mat-raised-button (click)="clearInputs(1)" class="clear-serial-button" matTooltip="נקה">
                                                    <mat-icon>clear</mat-icon>
                                                    <span>נקה</span>
                                                </button>
                                            </div>

                                            <div class="serial-hint">הזן מספר סידורי (6 ספרות)</div>
                                        </div>
                                    </div>

                                    <!-- Vest 2 -->
                                    <div class="serial-card" [class.valid]="serialValid2 === true" [class.invalid]="serialValid2 === false">
                                        <mat-icon *ngIf="serialValid2 === true" class="validation-icon success-icon">check_circle</mat-icon>
                                        <mat-icon *ngIf="serialValid2 === false" class="validation-icon error-icon">cancel</mat-icon>

                                        <img src="./assets/images/police_vest.png" class="serial-image" alt="Police Vest" />

                                        <div class="serial-content">
                                            <mat-label class="serial-title">אפוד קרמי #2</mat-label>

                                            <div class="serial-inputs">
                                                <mat-form-field *ngFor="let control of inputControls2; let i = index" class="serial-input-field" appearance="fill">
                                                    <input
                                                        matInput
                                                        maxlength="1"
                                                        type="text"
                                                        inputrestriction="numbers"
                                                        pattern="[0-9]*"
                                                        (input)="onInput($event, i, 2)"
                                                        (keydown.backspace)="onBackspace($event, i, 2)"
                                                        #inputBox2
                                                        [(ngModel)]="inputValues2[i]"
                                                        [ngModelOptions]="{standalone: true}"
                                                    />
                                                </mat-form-field>
                                                <button mat-raised-button (click)="clearInputs(2)" class="clear-serial-button" matTooltip="נקה">
                                                    <mat-icon>clear</mat-icon>
                                                    <span>נקה</span>
                                                </button>
                                            </div>

                                            <div class="serial-hint">הזן מספר סידורי (6 ספרות)</div>
                                        </div>
                                    </div>

                                    <!-- Road Cone -->
                                    <div class="serial-card" [class.valid]="serialValid3 === true" [class.invalid]="serialValid3 === false">
                                        <mat-icon *ngIf="serialValid3 === true" class="validation-icon success-icon">check_circle</mat-icon>
                                        <mat-icon *ngIf="serialValid3 === false" class="validation-icon error-icon">cancel</mat-icon>

                                        <img src="./assets/images/police_cones.png" class="serial-image" alt="Road Cones" />

                                        <div class="serial-content">
                                            <mat-label class="serial-title">נצנץ דרך</mat-label>

                                            <div class="serial-inputs">
                                                <mat-form-field *ngFor="let control of inputControls3; let i = index" class="serial-input-field" appearance="fill">
                                                    <input
                                                        matInput
                                                        maxlength="1"
                                                        type="text"
                                                        inputrestriction="numbers"
                                                        pattern="[0-9]*"
                                                        (input)="onInput($event, i, 3)"
                                                        (keydown.backspace)="onBackspace($event, i, 3)"
                                                        #inputBox3
                                                        [(ngModel)]="inputValues3[i]"
                                                        [ngModelOptions]="{standalone: true}"
                                                    />
                                                </mat-form-field>
                                                <button mat-raised-button (click)="clearInputs(3)" class="clear-serial-button" matTooltip="נקה">
                                                    <mat-icon>clear</mat-icon>
                                                    <span>נקה</span>
                                                </button>
                                            </div>

                                            <div class="serial-hint">הזן מספר סידורי (6 ספרות)</div>
                                        </div>
                                    </div>
                                }
                            </div>

                            <!-- Validation Status -->
                            @if (inSerialDev) {
                                <div class="validation-status">
                                    <div *ngIf="!inputVerifyComplete" class="status-warning">
                                        <mat-icon>warning</mat-icon>
                                        <span>יש למלא את כל 3 הפריטים (6 ספרות בכל אחד)</span>
                                    </div>
                                    <div *ngIf="inputVerifyComplete" class="status-success">
                                        <mat-icon>check_circle</mat-icon>
                                        <span>כל הפריטים הושלמו בהצלחה</span>
                                    </div>
                                </div>
                            }

                            <!-- Photo Upload Section -->
                            <div class="photo-upload-section">
                                <label class="camera-button" mat-raised-button color="primary">
                                    <mat-icon>camera_alt</mat-icon>
                                    צלם ציוד
                                    <input
                                        type="file"
                                        accept="image/*"
                                        capture="environment"
                                        (change)="onFilesSelectedStep1($event)"
                                        style="display: none;"
                                    />
                                </label>
                            </div>

                            <!-- Image Gallery -->
                            <div class="images-gallery" *ngIf="imageDataStep1?.length > 0">
                                <div class="image-item" *ngFor="let img of imageDataStep1; let i = index" (click)="openImagePreview(img, i, 'step1')">
                                    <img [src]="img" [alt]="'תמונת רכב ' + (i + 1)" loading="lazy" />
                                    <button mat-icon-button class="remove-image" (click)="removeFileStep1(i); $event.stopPropagation()" matTooltip="הסר תמונה">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <div class="image-overlay">
                                        <div>תמונת רכב {{ i + 1 }}</div>
                                        <div class="overlay-hint">לחץ להגדלה</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Empty State -->
                            <div *ngIf="!imageDataStep1?.length" class="empty-state">
                                <mat-icon>directions_car</mat-icon>
                                <p>עדיין לא צולמו תמונות רכב</p>
                                <p class="empty-hint">השתמש בכפתור המצלמה למעלה כדי לצלם</p>
                            </div>

                            <div class="step-actions">
                                <button
                                    mat-raised-button
                                    color="warn"
                                    class="next-button"
                                    (click)="stepper.next()"
                                    [disabled]="step1PhotosDisabled || (inSerialDev && !inputVerifyComplete)"
                                >
                                    המשך
                                    <mat-icon>arrow_back</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-step>

                    <!-- ==================== STEP 4: DAMAGE PHOTOS ==================== -->
                    <mat-step [completed]="!step2PhotosDisabled">
                        <ng-template matStepLabel>פגיעות</ng-template>

                        <div class="step-content">
                            <!-- Photo Upload Section -->
                            <div class="photo-upload-section">
                                <label class="camera-button" mat-raised-button color="primary">
                                    <mat-icon>camera_alt</mat-icon>
                                    צלם פגיעות
                                    <input
                                        type="file"
                                        accept="image/*"
                                        capture="environment"
                                        (change)="onFilesSelectedStep2($event)"
                                        style="display: none;"
                                    />
                                </label>
                            </div>

                            <!-- Image Gallery -->
                            <div class="images-gallery" *ngIf="imageDataStep2?.length > 0">
                                <div class="image-item" *ngFor="let img of imageDataStep2; let i = index" (click)="openImagePreview(img, i, 'step2')">
                                    <img [src]="img" [alt]="'פגיעה ' + (i + 1)" loading="lazy" />
                                    <button mat-icon-button class="remove-image" (click)="removeFileStep2(i); $event.stopPropagation()" matTooltip="הסר תמונה">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <div class="image-overlay">
                                        <div>פגיעה {{ i + 1 }}</div>
                                        <div class="overlay-hint">לחץ להגדלה</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Empty State -->
                            <div *ngIf="!imageDataStep2?.length" class="empty-state">
                                <mat-icon>photo_camera</mat-icon>
                                <p>עדיין לא צולמו תמונות פגיעות</p>
                                <p class="empty-hint">השתמש בכפתור המצלמה למעלה כדי לצלם</p>
                            </div>

                            <div class="step-actions">
                                <button
                                    mat-raised-button
                                    color="warn"
                                    class="next-button"
                                    (click)="stepper.next()"
                                    [disabled]="step2PhotosDisabled"
                                >
                                    המשך
                                    <mat-icon>arrow_back</mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-step>

                    <!-- ==================== STEP 5: COMPLETION ==================== -->
                    <mat-step>
                        <ng-template matStepLabel>סיום</ng-template>

                        <div class="step-content completion-content">
                            <mat-card class="completion-card">
                                <mat-card-header>
                                    <mat-card-title>הערות נוספות</mat-card-title>
                                </mat-card-header>
                                <mat-card-content>
                                    <mat-form-field appearance="fill" class="notes-field">
                                        <mat-label>פגיעות והערות - חובת דיווח מפורט גם אם מדובר בפגיעות ישנות</mat-label>
                                        <textarea
                                            matInput
                                            formControlName="הערות"
                                            inputrestriction="basic1"
                                            placeholder="הערות"
                                            rows="8"
                                            cdkTextareaAutosize
                                            cdkAutosizeMinRows="8"
                                            cdkAutosizeMaxRows="12"
                                        ></textarea>
                                    </mat-form-field>

                                    <!-- Missing Equipment Summary -->
                                    <div *ngIf="missingEquipmentSummary.length > 0" class="missing-equipment">
                                        <h3>חוסרים</h3>
                                        <mat-list>
                                            <mat-list-item *ngFor="let product of missingEquipmentSummary">
                                                <mat-icon matListIcon color="warn">warning</mat-icon>
                                                <span class="missing-text">{{ product.item }}, חסר {{ product.missing }}</span>
                                            </mat-list-item>
                                        </mat-list>
                                    </div>

                                    <!-- Low Bandwidth Option -->
                                    <div class="bandwidth-option">
                                        <mat-checkbox [(ngModel)]="useLowBandwidthMode" [ngModelOptions]="{standalone: true}">
                                            <div class="bandwidth-label">
                                                <mat-icon>signal_cellular_alt</mat-icon>
                                                <span>השתמש בתמונות קטנות (לחיבור איטי)</span>
                                            </div>
                                        </mat-checkbox>
                                        <div class="bandwidth-hint">תמונות יהיו באיכות נמוכה יותר לצורך העלאה מהירה</div>
                                    </div>
                                </mat-card-content>
                            </mat-card>

                            <button
                                (click)="onSubmit()"
                                [disabled]="wizardDisabled1 || wizardDisabled2"
                                type="submit"
                                class="submit-button"
                                mat-raised-button
                                color="primary"
                            >
                                סיום
                            </button>

                            <!-- Upload Modal Template -->
                            <ng-template let-modal #uploadModal class="transparentDialog">
                                <div mat-dialog-content>
                                    <div class="upload-progress">
                                        <app-loading [type]="9" [size]="'40px'"></app-loading>
                                        <div class="upload-size">{{ formattedUploadingSize }} / {{ formattedTotalSize }}</div>
                                        <circle-progress
                                            [percent]="uploadPercentage"
                                            [maxPercent]="100"
                                            [radius]="50"
                                            [outerStrokeColor]="'#78C000'"
                                            [innerStrokeColor]="'#C7E596'"
                                            [animationDuration]="300"
                                            [showSubtitle]="false"
                                            [showUnits]="true"
                                            [showTitle]="true"
                                            [unitsColor]="'#FFFFFF'"
                                            [titleColor]="'#FFFFFF'"
                                            [titleFontWeight]="'400'"
                                            [startFromZero]="false"
                                        ></circle-progress>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
            </form>
        }

        <!-- ==================== COMPLETION SUMMARY VIEW ==================== -->
        @case (EnumViewMode.COMPLETED) {
            <div translate="no" class="completion-view">
                <div class="success-header">
                    <mat-label class="success-title">משמרת נעימה</mat-label>
                    <mat-label class="success-emoji">❤️🚓</mat-label>
                </div>

                <mat-divider></mat-divider>

                <mat-card class="summary-card">
                    <mat-card-header>
                        <mat-card-title>סיכום ציוד</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="table-container">
                            <table #summary mat-table [dataSource]="equipmentSummary" class="summary-table">
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>ציוד</th>
                                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                                </ng-container>
                                <ng-container matColumnDef="value">
                                    <th mat-header-cell *matHeaderCellDef>מספר</th>
                                    <td mat-cell *matCellDef="let element">{{ element.value }}</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                        </div>
                        <button mat-raised-button color="warn" class="copy-button" (click)="copyTable()">
                            <mat-icon>content_copy</mat-icon>
                            העתק והדבק לוואטסאפ
                        </button>
                    </mat-card-content>
                </mat-card>

                <mat-divider></mat-divider>

                <mat-card class="summary-card">
                    <mat-card-header>
                        <mat-card-title>סיכום סוף משמרת</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <form [formGroup]="secondTabForm" (ngSubmit)="onSecondTabSubmit()" class="shift-summary-form">
                            <mat-form-field appearance="fill" class="form-field">
                                <mat-label>אירועים 🚨</mat-label>
                                <mat-select formControlName="drop1">
                                    <mat-option *ngFor="let num of numberOptions" [value]="num">{{ num }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="form-field">
                                <mat-label>רכבים 🚗</mat-label>
                                <mat-select formControlName="drop2">
                                    <mat-option *ngFor="let num of numberOptions" [value]="num">{{ num }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="form-field">
                                <mat-label>דו-גלגלי 🛴</mat-label>
                                <mat-select formControlName="drop3">
                                    <mat-option *ngFor="let num of numberOptions" [value]="num">{{ num }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="form-field">
                                <mat-label>אדם 🧍</mat-label>
                                <mat-select formControlName="drop4">
                                    <mat-option *ngFor="let num of numberOptions" [value]="num">{{ num }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field appearance="fill" class="form-field notes-field">
                                <mat-label>הערות 📝</mat-label>
                                <textarea
                                    matInput
                                    formControlName="comments"
                                    rows="4"
                                    placeholder="הקלד כאן הערות..."
                                ></textarea>
                            </mat-form-field>

                            <button mat-raised-button color="warn" type="button" class="copy-button" (click)="copyForm()">
                                <mat-icon>content_copy</mat-icon>
                                העתק והדבק לוואטסאפ
                            </button>
                        </form>
                    </mat-card-content>
                </mat-card>

                <mat-divider></mat-divider>

                <div class="gate-buttons">
                    <a class="gate-button" mat-raised-button href="tel:0543570197">
                        <mat-icon>fast_rewind</mat-icon>
                        פתח שער כניסה
                    </a>
                    <a class="gate-button" mat-raised-button href="tel:0549427839">
                        <mat-icon>fast_forward</mat-icon>
                        פתח שער יציאה
                    </a>
                </div>

                <mat-divider></mat-divider>

                <div class="new-zivud-section">
                    <button (click)="reload()" class="new-zivud-button" mat-stroked-button>
                        <mat-icon>local_police</mat-icon>
                        זיווד חדש
                    </button>
                </div>
            </div>
        }
    }
</div>

<!-- Problem Saving Modal -->
<ng-template let-modal #problemSaving>
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>
    <div mat-dialog-content>
        <div class="error-message">
            נתקלנו בבעיה בשמירת הנתונים, בבקשה צלמו שוב את הניידת ושימרו פעם נוספת
            <mat-icon>error</mat-icon>
        </div>
    </div>
</ng-template>
